export const getUserAuth = (): string | null => {
  const auth = localStorage.getItem("auth");
  if (auth) {
    return JSON.parse(auth).tokens;
  }
  return null;
};
